var agi = agi || {};
agi.expressions = agi.expressions || {};

(function(ImageService) {
    "use strict";
    var Expressor = function Expressor(environment, productData) {
        this.environment = environment;
        this.productData = productData;
    };

    var p = Expressor.prototype;

    // Firefox and Chrome have issues scaling and positioning a select box
    // correctly when using CSS transforms. Therefore, we'll fork the logic
    // to manually calculate the correct size and position ourselves.
    // Incidentally, this means that it wouldn't work on IE which
    // surprisingly handles CSS select scaling just fine. If Flash is dead,
    // it's rolling over in it's grave right now.
    var onBrokenBrowsers = (navigator.userAgent.indexOf("Firefox") >= 0) ||
                           (navigator.userAgent.indexOf("Chrome") >= 0) ||
                           ((navigator.userAgent.indexOf("Safari") >= 0) &&
                           ((navigator.userAgent.indexOf("iPhone") === -1 &&
                           navigator.userAgent.indexOf("iPad") === -1)));

    var handleResize = function handleResize(event) {
        setTimeout(formatSelectBoxes, 250);
    };

    //TODO: needs to revisit onBrokenBrowsers is still an issue without fullscreen
    /*
    if(onBrokenBrowsers) {
        window.addEventListener("resize", handleResize);
        window.addEventListener("orientationchange", handleResize);
        agi.expressions.Express.dispatcher.addEventListener(
            "fullscreenchange", handleResize
            );
    }
    */

    var selectBoxes = [];
    var requiredPersonalizations = {};
    var pristinePers = {};

    var requirePers = function requirePers(data) {
        requiredPersonalizations[data.name] = data;
    };

    var persRequirementIsFulfilled = function persRequirementIsFulfilled() {
        var rp = requiredPersonalizations;
        for(var p in requiredPersonalizations) {
            switch(rp[p].type) {
                case "text":
                    var input = document.getElementById(p);
                    if(input.value === rp[p].value ||
                       input.value === "") {
                        return false;
                    }
                    break;
                case "image":
                    if(!rp[p].src) {
                        return false;
                    }
                    break;
                default:
                    console.warning(
                        "Unknown personalization type: " + rp[p].type
                        );
            }
            if(rp[p].type === "text") {
            } else if(rp[p].type === "image") {

            }
        }

        return true;
    };

    var fileLoadComplete = function fileLoadComplete(event) {
        //event.item.target is a MovieClip instance in the Flash IDE
        //target.imageSlot is a MovieClip instance that is a child of target
        var exp = agi.expressions.ExpressionManager.expression;
        if(event.item.type === "image") {
            formatImage(event.result,
                event.item.target.imageSlot, event.item.transform,
                event.item.containerWidth, event.item.containerHeight);

            var imagePer = {id: event.item.id,
                            src: event.item.src,
                            type: createjs.LoadQueue.IMAGE,
                            transform: event.item.transform };

            // Store image data in personalizations
            var pers = exp.personalizations || {};
            var images = pers.images || [];

            //check if this is an update or insert
            var imageArrayIndex;
            for (var i = 0; i < images.length; i++) {
                if (images[i].id == event.item.id) {
                    imageArrayIndex = i;
                    break;
               }
            }

            if (imageArrayIndex === undefined) {
                images.push(imagePer);
            } else {
                images[imageArrayIndex] = imagePer;
            }

            pers.images = images;

            if(requiredPersonalizations.hasOwnProperty(event.item.id)) {
                requiredPersonalizations[event.item.id].src = event.item.src;
            }
            
            if (event.item.callback) {
                event.item.callback(imagePer);
            }

        }
    };

    var fileLoadFailed = function imageFailed(event) {
        window.alert("Sorry, your image failed to load. Try again later. :(");
    };

    var removeUploadedImage = function(slot, id) {
        var exp = agi.expressions.ExpressionManager.expression;
        var pers = exp.personalizations || {};
        var images = pers.images || [];

        var removedImageIdx;
        for (var i = 0; i < images.length; i++) {
            if (images[i].id == id) {
                removedImageIdx = i;
                break;
           }
        }
        if (removedImageIdx !== undefined) {
            pers.images.splice(removedImageIdx, 1);
        }

        // Dive into the image container and remove the image.
        var numChildren = slot.getChildAt(0).children.length;
        var topLayerChild = slot.getChildAt(0).children[numChildren-1];
        if (topLayerChild.hasOwnProperty('children') &&
            topLayerChild.children[0].hasOwnProperty('image')) {
            slot.getChildAt(0).removeChild(topLayerChild);
        }

    };

    var formatImage = function(image, slot, transform, imageContainerWidth, imageContainerHeight) {
        //slot is a MovieClip in the Flash IDE
        var container = new createjs.Container();
        var bitmap = new createjs.Bitmap(image);

        var scale = Math.sqrt(transform[0] * transform[0] +
                              transform[1] * transform[1]);
        var rotation = 180 * Math.atan2(transform[1], transform[0])/Math.PI;
        var x = transform[4];
        var y = transform[5];

        bitmap.setTransform(x, y, scale, scale, rotation);
        container.addChild(bitmap);


        while (slot.children.length > 0) {
            slot.removeChildAt(slot.children.length - 1);
        }

        // Adjust the registration point if need be.
        container.regX = imageContainerWidth/2;
        container.regY = imageContainerHeight/2;
        slot.addChild(container);

    };

    var loadImage = function loadImage(data) {
        var queue = agi.expressions.ExpressionManager.loadQueue;
        queue.removeEventListener("fileload", fileLoadComplete);
        queue.removeEventListener("error", fileLoadFailed);
        queue.addEventListener("fileload", fileLoadComplete);
        queue.addEventListener("error", fileLoadFailed);
        queue.loadFile({
            target:data.target,
            id:data.id,
            src:data.url,
            type:createjs.LoadQueue.IMAGE,
            transform:data.transform,
            containerWidth: data.containerWidth,
            containerHeight: data.containerHeight,
            callback: data.callback
            });
    };

    p.handleEvent = function handleEvent(event) {
        this[event.type](event.data);
    };

    p.hideFullScreenCloseBtn = function hideFullScreenCloseBtn() {
        var closeBtn = document.querySelector("#expression-close-button");
        if (closeBtn) {
            closeBtn.style.display = "none";
        }
    };

    p.showFullScreenCloseBtn = function showFullScreenCloseBtn() {
        var closeBtn = document.querySelector("#expression-close-button");
        if (closeBtn) {
            closeBtn.style.display = "block";
        }
    };

    p.getSavedPersImage = function getSavedPersImage(id) {
        var savedPersImage;
        var exp = agi.expressions.ExpressionManager.expression;
        var pers = exp.personalizations || {};
        var images = pers.images || [];

        for (var i = 0; i < images.length; i++) {
            if (images[i].id == id) {
                savedPersImage = images[i];
                break;
           }
        }
        return savedPersImage;
    };

    p.addAnImage = function addAnImage(data) {
        var passthru = {activeImageId: data.id,
                        activeImageTarget: data.target,
                        activeImageContainerW: data.width,
                        activeImageContainerH: data.height,
                        callback: data.callback};

        var savedPersImage = this.getSavedPersImage(data.id);

        var imageService;
        var exp = agi.expressions.ExpressionManager.expression;

        var imageOverlaySrc = exp.addAPhotoOverlay.children[0].image.src;
        var imageBackgroundSrc = exp.addAPhotoBackground.children[0].image.src;

        if (savedPersImage) {
            var editOptions = {action: 'edit',
                               imageUrl: savedPersImage.src,
                               imageOverlayUrl: imageOverlaySrc,
                               imageBackgroundUrl: imageBackgroundSrc,
                               transform: savedPersImage.transform,
                               width: data.width,
                               height: data.height,
                               passthru: passthru};
            imageService = new agi.expressions.ImageService(editOptions);

        } else {
            var environ = 'prod';
            var hostname = window.location.hostname;
            if (hostname.search('dev') == 0) {
                environ = 'dev';
            } else if (hostname.search('stage') == 0) {
                environ = 'stage';
            }
            var sitegroup = this.environment.sitegroup || 'ag';
            var uploadConvertEditOptions = {action: 'uploadConvertEdit',
                                            sitegroup: sitegroup,
                                            environment: environ,
                                            imageOverlayUrl: imageOverlaySrc,
                                            imageBackgroundUrl: imageBackgroundSrc,
                                            width: data.width,
                                            height: data.height,
                                            passthru: passthru };
            imageService = new agi.expressions.ImageService(uploadConvertEditOptions);
        }

        imageService.addEventListener("imageServiceComplete",
                                      this.imageServiceCompleteHandler.bind(this));

        imageService.addEventListener("imageServiceFailed",
                                      this.imageServiceFailedHandler.bind(this));

        imageService.openDialog();
        this.hideFullScreenCloseBtn();
    };

    p.imageServiceCompleteHandler = function imageServiceCompleteHandler(e) {
        this.showFullScreenCloseBtn();
        if (e.data && (e.data.length >= 0)) {
            if (e.data[0].imageUrl) {
                loadImage({
                    target:e.passthru.activeImageTarget,
                    id:e.passthru.activeImageId,
                    url:e.data[0].imageUrl,
                    transform:e.data[0].transform,
                    containerWidth: e.passthru.activeImageContainerW,
                    containerHeight: e.passthru.activeImageContainerH,
                    callback: e.passthru.callback
                });
            } else {
                removeUploadedImage(e.passthru.activeImageTarget,
                                    e.passthru.activeImageId);
            }
        }
    };

    p.imageServiceFailedHandler = function imageServiceFailedHandler(e) {
        this.showFullScreenCloseBtn();
        console.error("imageServiceFailed ", e.error, e.data, e.passthru);
        window.alert("Uh oh! Our image service is down at this time. Please try again later.");
    };

    p.insertImage = function insertImage(data) {
        var savedPersImage = this.getSavedPersImage(data.key);
        if (savedPersImage) {
            var em = agi.expressions.ExpressionManager;
            var image = em.loadQueue.getItem(data.key);
            if(image !== undefined) {
                //createjs newer version does not provide image.tag
                var img;
                if (image.tag) {
                    img = image.tag;
                } else {
                    img = new Image();
                    img.src = image.src;
                }
                formatImage(img, data.target.imageSlot, image.transform,
                            data.width, data.height);
            }
        }
    };

    p.insertSelection = function insertSelection(data) {
        var exp = agi.expressions.ExpressionManager.expression;
        var pers = exp.personalizations;
        var value = pers[data.key];
        var dispatcher = agi.expressions.Express.dispatcher;
        dispatcher.removeEventListener(data.key + "Selected", data.target);
        dispatcher.addEventListener(data.key + "Selected", function(event) {
            data.target.gotoAndStop(event.value);
        });
        if(value) {
            // The stage and child objects have not been fully assembled
            // so we need to use setTimeout it ensure all is well before
            // we begin to manipulate them. This may be a CreateJS bug or
            // simply just poor implementation.
            setTimeout(function(e) {
                data.target.gotoAndStop(value);
                }, 1);
        }
    };

    p.playAudio = function playAudio(data) {
        var loopCount = data.loops != null ? data.loops : 0;
        var delay = data.delay != null ? data.delay : 0;
        createjs.Sound.play(
            data.name, createjs.Sound.INTERRUPT_ANY, delay, 0, loopCount);
    };

    p.stopAudio = function stopAudio(data) {
        createjs.Sound.stop();
    };

    p.insertPersonalization = function insertPersonalization(data) {
        var exp = agi.expressions.ExpressionManager.expression;
        var pers = exp.personalizations;
        if(data.target.children[0].hasOwnProperty("text")) { // Insert into text obj.
            data.target.children[0].text = pers[data.key];
        }
    };

    p.showSelectBox = function showSelectBox(data) {
        var container;
        /*
        if(onBrokenBrowsers) {
            container = document.getElementById("expression-wrapper");
        } else {
            container = document.getElementById("agi-expression-overlay");
        }
        */
        container = document.getElementById("agi-expression-overlay");
        var select = this.getSelectBox(data);
        container.appendChild(select);
        data.target.visible = false;
        select.addEventListener("change", function(event) {
            var t = event.currentTarget;
            selectOption(data.name,t.options[t.selectedIndex].value);
        });
        selectOption(data.name, select.value);
    }

    var selectOption = function selectOption(key, value) {
        var exp = agi.expressions.ExpressionManager.expression;
        var pers = exp.personalizations;
        pers[key] = value;
        var dispatcher = agi.expressions.Express.dispatcher;
        var event = new createjs.Event(key + "Selected");
        event.value = value;
        dispatcher.dispatchEvent(event);
    };

    p.showTextInput = function showTextInput(data) {
        // Recycle value from personalizations if they exist.
        var persData = agi.expressions.ExpressionManager.expression.personalizations[data.name];
        if(persData !== undefined) {
            data.text.text = persData;
        }

        if (!pristinePers.hasOwnProperty(data.name)) {
            pristinePers[data.name] = true;
        }

        // Text fields are required so register them. Submit uses this
        // to make sure we can continue customization.
        data.type = "text";
        data.value = data.text.text;
        if(!requiredPersonalizations.hasOwnProperty(data.name)) {
            requirePers(data);
        }

        var canvas = document.getElementById(
            "expression-" + this.productData.id + "-canvas"
            );
        var form = this.getForm(data);
        var input = this.getTextInput(data);
        input.dataset.suffix = data.suffix ? data.suffix : "";
        input.style.visibility = "visible";
        form.appendChild(input);
        var overlay = document.getElementById("agi-expression-overlay");
        overlay.appendChild(form);
        data.text.visible = false;

        input.onclick = function() {
            pristinePers[data.name] = false;
            this.setSelectionRange(0, this.value.length);
        }
        //This is to fix if you use tab to go between input fields.
        input.onfocus = function() {
            pristinePers[data.name] = false;
        }
    };

    p.submitInput = function submitInput(data) {
        // Check personalization requirements before doing anything.
        if (data && data.checkRequiredPers) {
            if(persRequirementIsFulfilled() === false) return;
        }

        var form = this.getForm(data);
        var expression = agi.expressions.ExpressionManager.expression;
        var pers = expression.personalizations || {};
        for(var i = 0; i < form.elements.length; i++) {
            var input = form.elements[i];
            if (pristinePers.hasOwnProperty(input.id) && pristinePers[input.id]) {
                pers[input.id] = "";
            } else {
                pers[input.id] = input.value + input.dataset.suffix;
            }
            if(input.tagName === "INPUT") {
                input.blur();
            }
            input.style.visibility = "hidden";
        }

        for(i = 0; i < selectBoxes.length; i++) {
            selectBoxes[i].style.visibility = "hidden";
        }

        // So far, so good. Now move the playhead.
        agi.expressions.ExpressionManager.expression.play();
    };

    p.hideOnPickup = function hideOnPickup(data) {
        if(this.environment.mode === "pickup") {
            data.displayObject.visible = false;
        }
    };

    p.hideOnInit = function hideOnInit(data) {
        if(this.environment.mode === "init") {
            data.displayObject.visible = false;
        }
    };

    p.hideIfNotAMember = function hideIfNotAMember(data) {
        data.displayObject.visible = this.environment.maySend;
    };

    p.send = function send() {
        var manager = agi.expressions.ExpressionManager;
        var pers = manager.expression.personalizations;
        var encoded = encodeURIComponent(JSON.stringify(pers));

        manager.helper.send(encoded);
    };

    p.getForm = function(data) {
        var self = this;
        var form = document.getElementById("agi-expression-form");
        if(form === null) {
            form = document.createElement("form");
            form.id = "agi-expression-form";
            form.action = "#";
            form.addEventListener("submit", function(event) {
                event.preventDefault();
                //self.submitInput();  to make Go on keyboard to work
            });
        }

        return form;
    };

    p.getSelectBox = function(data) {
        var select = document.getElementById(data.name);
        if(select === null) {
            select = document.createElement("select");
            select.id = data.name;
            for(var i = 0; i < data.options.length; i++) {
                var option = document.createElement("option");
                option.value = data.options[i];
                option.text = data.options[i];
                select.add(option);
            }
            select.setAttribute("data-font", data.target.font);
            select.setAttribute("data-width", data.target.width);
            select.setAttribute("data-height", data.target.height);
            select.setAttribute("data-x", data.target.x);
            select.setAttribute("data-y", data.target.y);
            selectBoxes.push(select);
        }
        select.style.visibility = "visible";
        formatSelectBox(select);

        return select;
    };

    var formatSelectBoxes = function formatSelectBoxes() {
        for(var i = 0; i < selectBoxes.length; i++) {
            formatSelectBox(selectBoxes[i]);
        }
    };

    var formatSelectBox = function formatSelectBox(select) {
        var fontData = select.getAttribute("data-font");
        var selectWidth = select.getAttribute("data-width");
        var selectHeight = select.getAttribute("data-height");
        var selectX = select.getAttribute("data-x");
        var selectY = select.getAttribute("data-y");
        select.style.position = "absolute";
        select.style.display = "none";
        select.style.display = "block";

        if(onBrokenBrowsers) {
            var overlay = document.getElementById("agi-expression-overlay");
            var scale = parseFloat(overlay.style.transform.substr(6).split(",")[0]);
            select.style.font = (fontData.split("px")[0] * scale) + "px '" + fontData.split("'")[1] + "'";
            select.style["width"] = (selectWidth * scale) + "px";
            select.style["height"] = (selectHeight * scale) + "px";
            if(agi.expressions.ExpressionManager.isFullscreen) {
                var bounds = overlay.getBoundingClientRect();
                select.style.left = (selectX * scale + bounds.left) + "px";
                select.style.top = (selectY * scale + bounds.top) + "px";
            } else {
                select.style.left = (selectX * scale) + "px";
                select.style.top = (selectY * scale) + "px";
            }
        } else {
            select.style.font = fontData;
            select.style["width"] = selectWidth + "px";
            select.style["height"] = selectHeight + "px";
            select.style.left = selectX + "px";
            select.style.top = selectY + "px";
        }

    };

    p.getTextInput = function(data) {
        var input = document.getElementById(data.name);
        if(input === null) {
            input = document.createElement("input");
            input.type = "text";
            input.id = data.name;
            input.value = data.text.text;
            input.style.position = "absolute";
            input.style.display = "block";
            input.style.backgroundColor = "transparent";
            input.style.color = data.text.color || "#000000";
            input.style.font = data.text.font;
            input.style.textAlign = data.text.textAlign;
            //input.style.width = data.text.width + "px";
            input.style.width = data.text.lineWidth + "px";
            input.style.height = data.text.height + "px";
            input.style.padding = "0px";
            input.style.margin = "0px";
            input.style.border = "0px";
            //input.style.left = (data.text.x - (data.text.width * .5)) + "px";
            input.style.left = data.x + "px";
            input.style.top = data.y + "px";
            input.autocorrect = false;
            input.autocomplete = "off";
            input.spellcheck = false;
        }
        return input;
    };

    agi.expressions.Expressor = Expressor;
}(agi.expressions.ImageService));
